module.exports = __webpack_public_path__ + "images/logout21aa61c0ede07e82b80858472c94dda8.svg";